import { render } from "./UpdateCurrentCar.vue?vue&type=template&id=f6df4e6e"
import script from "./UpdateCurrentCar.vue?vue&type=script&lang=js"
export * from "./UpdateCurrentCar.vue?vue&type=script&lang=js"

import "./UpdateCurrentCar.vue?vue&type=style&index=0&id=f6df4e6e&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\vue_php_crud\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__